import { jsx as _jsx } from "react/jsx-runtime";
import { BKJButtonWrapper } from './BKJButton.styled.js';
import { forwardRef } from 'react';
import { BKJLoadingSpinner } from '../BKJLoadingSpinner/index.js';
export const BKJButton = forwardRef((props, ref) => {
    const { children, isLoading, className, type = 'button', ...rest } = props;
    return (_jsx(BKJButtonWrapper, { ...rest, className: className, type: type, "aria-busy": isLoading || undefined, ref: ref, children: isLoading ? _jsx(BKJLoadingSpinner, { variant: "Small" }) : children }));
});
//# sourceMappingURL=BKJButton.js.map